module.exports = __webpack_public_path__ + "static/media/temp_w_domu_grzanie_1.b4e9fbdc.svg";